export const branch = [
    {
        id: "1",
        name: "Discover Our Showrooms Addresses.",
        buttontext: "Find a Store",
        img_url: "/images/store.png",
        route: '/store'
    },
    {
        id: "2",
        name: "Discover Our Service Center Addresses.",
        buttontext: "Find a Service Center",
        img_url: "/images/service.png",
         route: '/service'
    },
]